import React, { ReactNode } from "react";
import { css } from "@emotion/react";

type Props = {
    children: ReactNode,
};

const CartPopupContainer: React.FC<Props> = ({ children }) => {
    const style = css`
        display: flex;
        height: 100%;
    `;

    return (
        <div css={style} data-test-id={"cart-popup-container"}>
            {children}
        </div>
    );
};

export default CartPopupContainer;